export default {
  main: {
    title: 'Verificação de Versão',
    language: 'Português',
    intro:
      'A verificação de versão é realizada por meio da correspondência dos valores de hash MD5 ou SHA256 entre as versões. Certifique-se de baixar a carteira TokenPocket por meio de canais oficiais para evitar ser enganado. Para instruções sobre como obter os valores de hash MD5 ou SHA256 de uma versão, por favor ',
    tutorial: 'consulte o tutorial >',
    system: 'Sistema Operacional',
    android: 'Android',
    ios: 'iOS',
    version: 'Versão',
    allVersion: 'Todas',
    appChannel: 'Canal do Aplicativo',
    developer: 'desenvolvedor',
    allChannel: 'Todos',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Registro de Versão',
    check: 'Detalhes',
    versionLog: 'Registro de Versão',
    confirm: 'Confirmar',
    aboutIOS: 'Sobre a Versão iOS',
    IOSDesc:
      'Para versões do iOS, oferecemos nosso aplicativo apenas na App Store. Somente aplicativos baixados pela App Store podem ser instalados corretamente. Portanto, ao usar dispositivos Apple, certifique-se de autenticar a App Store como o único canal de download.',
    IOSDesc_2:
      'O desenvolvedor da versão baixada da App Store antes de 8 de outubro de 2022 é a TOKENPOCKET FOUNDATION LTD, que é uma versão anterior desenvolvida pela TokenPocket. É uma carteira legítima que pode ser usada normalmente, mas o serviço de atualização será temporariamente suspenso.',
    aboutAndroid: 'Sobre a Versão do Android',
    androidDesc: 'As opções de download do TokenPocket para Android incluem atualmente o site oficial, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store e Vivo App Store. Em algumas lojas de aplicativos, não é possível obter o arquivo de instalação APK durante o processo de download, portanto, não é possível realizar a verificação MD5 ou SHA256. Portanto, ao fazer o download, verifique claramente as informações do desenvolvedor, consultando abaixo!',
    IOSAppName: 'Nome do Aplicativo:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Ícone do Aplicativo:',
    AppDeveloper: 'Desenvolvedor:',
    downloadLink: 'URL de Download:',
    copied: 'Copiado!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Siga-nos',
    desc1: 'TokenPocket Os funcionários não enviarão mensagens privadas!',
    desc2:
      'uidado! Você está entrando na comunidade TokenPocket, pode haver alguém se passando por nós para lhe enviar mensagens privadas! Esteja ciente de que qualquer pessoa que envie mensagens privadas pode ser um golpista! Nós nunca entraremos em contato com você primeiro!',
    desc3: 'Entendido, digite',
  },
  COMMON: {
    LAYOUT: {
      features: 'características',
      products: 'Produtos',
      buyCryptoFooter: 'Comprar',
      mobileWallet: 'Carteira móvel',
      mobileWalletDesc: 'Carteira móvel de Crypto e DeFi no blockchain.',
      hardwareWallet: 'Carteira de hardware',
      hardwareWalletDesc: 'Obtenha seu KeyPal, para proteger seus ativos.',
      extensionWallet: 'Extensão da carteira',
      extensionWalletDesc: 'Uma carteira melhor no seu computador.',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Verificação de versão',
      versionVerificationDesc: 'Verifique sua carteira.',
      approvalDetector: 'Detector de aprovações',
      approvalDetectorDesc: 'Veja e desaprove seus tokens aprovados.',
      tokenSecurity: 'Segurança de tokens',
      tokenSecurityDesc: 'Verifique se o token é seguro pelo endereço do contrato.',
      keyGenerator: 'Gerador de chaves',
      keyGeneratorDesc: 'Gere chaves públicas e privadas aleatoriamente para várias redes.',
      tokenProfile: 'Perfil de token',
      tokenProfileDesc: 'Saiba todas as informações sobre o token.',
      tokenClaim: 'Reivindicação de tokens',
      tokenClaimDesc: 'Reivindique seu airdrop.',
      easyInscription: 'Inscrição fácil',
      easyInscriptionDesc: 'Uma ferramenta de inscrição segura.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'Uma ferramenta de envio em massa para NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Envie tokens para vários destinatários de uma vez.',
  
      trade: 'Comércio',
      swap: 'Troca',
      swapDesc: 'Negocie com os melhores preços.',
      bridge: 'Ponte',
      bridgeDesc: 'Atravesse ativos de uma cadeia para outra sem problemas.',
      buyCrypto: 'Comprar',
      buyCryptoDesc: 'Compre criptomoedas com seus cartões de crédito.',
      market: 'Mercado',
      marketDesc: 'Insights em tempo real para descobrir tokens populares.',
  
      information: 'Informação',
      blockchainGuide: 'Guia da Blockchain',
      tronWallet: 'Guia TRON',
      iostWallet: 'Guia IOST',
      tpMan: 'Homem TP',
  
      developers: 'Desenvolvedores',
      github: 'Github (TP-Lab)',
      devCenter: 'Centro de Programadores',
      developersDesc: 'Documentação para desenvolvedores TokenPocket.',
      subToken: 'Enviar token',
      subTokenDesc: 'Envie seu token.',
      subDApp: 'Enviar DApp',
      subDAppDesc: 'Envie seu DApp, e ele será exibido após a auditoria.',
      subNFT: 'Enviar NFT',
      subNFTDesc: 'Envie seu NFT e arte.',
      subChain: 'Enviar cadeia',
      subChainDesc: 'Envie sua blockchain.',
      bugBounty: 'Bug Bounty',
  
      tools: 'Ferramentas',
  
      build: 'Construir',
  
      learn: 'Aprender',
  
      explorer: 'Explorar',
  
      company: 'Companhia',
      about: 'Acerca (de)',
      careers: 'Carreiras',
      pressKit: 'Kit de marca',
      swagShop: 'Loja Swag',
  
      support: 'Suporte',
      helpCenter: 'Centro de ajuda',
      helpCenterDesc: 'Seus recursos para obter respostas e assistência.',
      contactUs: 'Contate-Nos',
      contactUsDesc: 'Compartilhe suas sugestões e faça qualquer pergunta.',
      forum: 'Fórum',
      forumDesc: 'Desfrute de suas conversas com os membros da comunidade.',
  
      legal: 'Legal',
      privacyPolicy: 'Política de Privacidade',
      terms: 'Termos de Utilização',
  
      toHome: 'Página principal',
      defiWallet: 'Carteira DeF',
      ETHWallet: 'Carteira Ethereum',
      ethWallet: 'Carteira ETH',

      dappStore: 'Loja de DApp'
    }
  }
};
